// removed by extract-text-webpack-plugin
module.exports = {"main":"_2eHOEeeVoDfmn3TCZFyoPG","box":"jOK_ma4qITnqb4C2t5QRb"};


//////////////////
// WEBPACK FOOTER
// ./src/components/EmptyPage/index.less
// module id = 391
// module chunks = 0